import { checkEnvironment } from '@saviynt/common';

const getAccountListApiUrl = () => {
  const { GATEWAY_API_URL } = checkEnvironment();

  return `${GATEWAY_API_URL}/api/pam/accounts`;
};

export default getAccountListApiUrl;
